import React from 'react';
import '../styles/LogosUDEA.css';

//Imagenes
import nanoBioCancer from '../imgs/logos/Logo nano biocancer.jpeg';
import colombiaCientifica from '../imgs/logos/Logo colombia cientifica.jpeg';
import UDEA from '../imgs/logos/827px-Escudo-UdeA.svg.png';


export default function LogosUDEA(props) {
    return (
        <div className={`${props.componente}__div--container`}>
            <div className={`${props.componente}__div--container-imagenes`}>
                <img className={`${props.componente}__img--logo-udea`} src={UDEA} alt='colombia-cientifica.jpeg'/>
                <img src={colombiaCientifica} alt='colombia-cientifica.jpeg'/>
                <img src={nanoBioCancer} alt='nano-biocancer.jpeg'/>
            </div>
        </div>
    )
}
